import { Action, createReducer, on } from '@ngrx/store';
import * as AddBillingitemTopackageWizardActions from './actions';
import { State, initialState } from './state';

export const addBillingitemTopackageWizardFeatureKey = 'addBillingitemTopackageWizardV26';

const addBillingitemTopackageWizardReducer = createReducer(
  initialState,

  on(AddBillingitemTopackageWizardActions.selectInitStep, (state, { initStep }) => ({
    ...state,
    initStep,
    dueDatesStep: { activationDate: null, deactivationDate: null },
  })),
  on(AddBillingitemTopackageWizardActions.selectDueDatesStep, (state, { dueDatesStep }) => ({
    ...state,
    dueDatesStep,
  })),
  on(AddBillingitemTopackageWizardActions.exitAddBillingitemTopackageWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(AddBillingitemTopackageWizardActions.destroyWizard, (state) => ({
    ...state,
    initStep: null,
    dueDatesStep: null,
    errorMessage: null,
    request: null,
    response: null,
  })),
  on(AddBillingitemTopackageWizardActions.createNewAddBillingitemTopackageSuccess, (state, { response }) => ({
    ...state,
    response,
  })),
  on(AddBillingitemTopackageWizardActions.createNewAddBillingitemTopackageFail, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return addBillingitemTopackageWizardReducer(state, action);
}
